import { render, staticRenderFns } from "./program-list-filter.vue?vue&type=template&id=23961091&"
import script from "./program-list-filter.vue?vue&type=script&lang=js&"
export * from "./program-list-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports